@if(displaySpinner){
  <div class="centered-content">
    <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
  </div>
}@else{
<div>
    <mat-form-field>
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
            <input matStartDate (dateChange)="updateStart($event)" [value]="startDate" placeholder="Start date">
            <input matEndDate (dateChange)="updateEnd($event)" [value]="endDate" placeholder="End date">
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="updateGraph()">Get Data</button>
</div>
<apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [title]="chartOptions.title"
    [xaxis]="chartOptions.xaxis"
    [plotOptions]="chartOptions.plotOptions"
    [dataLabels]="chartOptions.dataLabels"
    [colors]="chartOptions.colors"
    [tooltip]="chartOptions.tooltip">
</apx-chart>
<br>
<br>
<apx-chart
    [series]="cumulativeChartOptions.series"
    [chart]="cumulativeChartOptions.chart"
    [title]="cumulativeChartOptions.title"
    [xaxis]="cumulativeChartOptions.xaxis"
    [plotOptions]="cumulativeChartOptions.plotOptions"
    [dataLabels]="cumulativeChartOptions.dataLabels"
    [tooltip]="cumulativeChartOptions.tooltip">
</apx-chart>
}
